import DealMenu from '@/components/deal/deal-menu/deal-menu';
import TextConvo from '@/components/sms/text-convo/text-convo';
import TextRecap from '@/components/sms/text-recap/text-recap';
import { Badge } from '@/components/ui/badge.tsx';
import { HubDealPageHeader } from '@/components/ui/layout/headers';
import useGoToDeal from '@/hooks/use-go-to-deal';
import { cn } from '@/lib/utils';
import { Deal } from '@/models/registry';
import { ChevronRight } from 'lucide-react';
import { observer } from 'mobx-react-lite';

const ArchivedNonMobileHeader = observer(({ deal }: { deal: Deal }) => {
  const dealShortId = deal.short_id ?? '';
  const { ai_summary, sms_conversation } = deal;
  const { goToDeal } = useGoToDeal();

  return (
    <HubDealPageHeader
      isArchived={true}
      separator={<ChevronRight className={cn('h-5 w-5', {})} />}
      shortIdWrapper={
        <div
          className="pl-1.5 text-nowrap cursor-pointer"
          onClick={() => {
            goToDeal({ dealShortId, isForInbox: false });
          }}
        >
          {dealShortId}
        </div>
      }
      rowLeft={
        <>
          <DealMenu deal={deal} withHokeyListener />
          <Badge
            variant="outline"
            className="text-xs text-gray-500 bg-gray-100"
          >
            Archived
          </Badge>
        </>
      }
      rowRight={
        <div className="flex flex-row items-center gap-3">
          <TextRecap
            aiSummary={ai_summary}
            dealShortId={dealShortId}
            smsConversation={sms_conversation}
          />
          <TextConvo
            smsConversation={sms_conversation}
            dealShortId={dealShortId}
          />
        </div>
      }
    />
  );
});

export default ArchivedNonMobileHeader;
